import React, { useState, useMemo } from "react";
import { Box, Card, Tabs, Tab } from "@mui/material";
import { ActivityStyles } from "./ActivityStyles";
import Claims from "./Claims/Claims";
import Billing from "./Billing/Billing";
import Policy from "./Policy/Policy";
import { useTranslation } from "react-i18next";

const Activity: React.FC = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);

  const tabComponents = [<Policy />, <Claims />, <Billing />];
  const tabLabels = ["Policy", "Claims", "Billing"];

  return (
    <Box 
      id="activity_container"
      data-test-id="test-activity_container"
      aria-label="Activity Container"
      sx={ActivityStyles.activity}
    >
      <Tabs
        id="activity_tabs"
        data-test-id="test-activity_tabs"
        aria-label="Activity Tabs"
        onChange={(e, newValue) => setValue(newValue)}
        value={value}
        allowScrollButtonsMobile
      >
        {tabLabels.map((label, index) => (
          <Tab
            id={`activity_tab-${label.toLowerCase()}`}
            data-test-id={`test-activity_tab-${label.toLowerCase()}`}
            aria-label={`${label} Activity Tab`}
            key={index}
            label={t(label)}
            value={index}
            sx={{
              color: "#383D4E",
              fontFamily: "Playfair Display",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "20px",
              textTransform: "none",
            }}
          />
        ))}
      </Tabs>
      <Card 
        id="activity_content"
        data-test-id="test-activity_content"
        aria-label="Activity Content"
        sx={ActivityStyles.container}
      >
        {tabComponents[value]}
      </Card>
    </Box>
  );
};

export default Activity;
